module.exports = [
  {
    key: 'help_support',
    name: 'Help & Support',
    link: '/help',
  },
];
